'use client';

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

interface ProjectsTableSkeletonProps {
  rows?: number;
}

export function ProjectsTableSkeleton({ rows = 7 }: ProjectsTableSkeletonProps) {
  return (
    <div className="border rounded-lg bg-card">
      {/* Toolbar skeleton */}
      <div className="flex items-center justify-between px-4 py-2.5 border-b">
        <Skeleton className="h-4 w-20" />
      </div>
      <div className="overflow-auto">
        <Table className="table-fixed">
          <TableHeader>
            <TableRow className="hover:bg-transparent">
              <TableHead className="sticky top-0 bg-background z-10 border-b w-[38%]">Project</TableHead>
              <TableHead className="sticky top-0 bg-background z-10 border-b w-[12%]">Country</TableHead>
              <TableHead className="sticky top-0 bg-background z-10 border-b w-[18%] text-right">Duration</TableHead>
              <TableHead className="sticky top-0 bg-background z-10 border-b w-[8%]">CFP</TableHead>
              <TableHead className="sticky top-0 bg-background z-10 border-b w-[12%]">Source</TableHead>
              <TableHead className="sticky top-0 bg-background z-10 border-b w-[10%] text-right">Updated</TableHead>
              <TableHead className="sticky top-0 bg-background z-10 border-b w-[88px]"></TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {Array.from({ length: rows }).map((_, i) => (
              <TableRow
                key={i}
                className={cn(
                  'border-b border-border/60',
                  i % 2 === 1 ? 'bg-muted/10' : 'bg-background'
                )}
              >
                <TableCell className="py-3">
                  <div className="space-y-1.5">
                    <Skeleton className="h-4 w-3/4" />
                    <Skeleton className="h-3 w-1/2" />
                  </div>
                </TableCell>
                <TableCell className="py-3">
                  <Skeleton className="h-4 w-16" />
                </TableCell>
                <TableCell className="py-3 text-right">
                  <Skeleton className="h-4 w-28 ml-auto" />
                </TableCell>
                <TableCell className="py-3">
                  <Skeleton className="h-5 w-10 rounded-full" />
                </TableCell>
                <TableCell className="py-3">
                  <Skeleton className="h-5 w-20 rounded-full" />
                </TableCell>
                <TableCell className="py-3 text-right">
                  <Skeleton className="h-4 w-12 ml-auto" />
                </TableCell>
                <TableCell className="py-3">
                  <div className="flex items-center gap-1 justify-end">
                    <Skeleton className="h-7 w-7 rounded" />
                    <Skeleton className="h-7 w-7 rounded" />
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
